export const BASE_URL = 'sessions';

export const TOKEN_ERROR_CODES = ['E_JWT_TOKEN_EXPIRED'];

export const SIGN_OUT_ERROR_CODES = ['E_INVALID_JWT_TOKEN'];
